import {
    useMemo,
} from 'react';

import {
    DEFAULT_LOCALE,
} from '../constants';

export default function usePaymentLocale(): string {
    return useMemo(() => {
        const browserLocale = navigator.languages?.[0] || navigator.language || DEFAULT_LOCALE;

        return browserLocale.split('-')[0]?.toLocaleLowerCase() || DEFAULT_LOCALE;
    }, []);
}
